import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const SearchFilter = (props) => {
  const showSearch = props.searchActive ? 'active' : '';

  function handleSearch(e) {
    props.onSearch(e.target.value);
  }

  function handleSubmit(e) {
    e.preventDefault()
    props.onSubmit()
  }

  return (
    <div className={`c-shop-search-filter ${showSearch}`}>
      <form onSubmit={handleSubmit}>
        <input
          type="search"
          placeholder={props.placeholder}
          value={props.searchText}
          onChange={handleSearch}
          className="c-shop-search-filter__search-field"
        />
        <input 
          type="submit"
          value=""
          disabled={(props.postsLoading) ? true : false}
          className="c-shop-search-filter__submit"
        /> 
      </form>
    </div>
  )
}

export default SearchFilter


// WEBPACK FOOTER //
// ./src/js/shop/components/SearchFilter.js